import { FC, useEffect, useState } from 'react';
import AgentChatWindow from './components/AgentChatWindow/AgentChatWindow';
import AgentChatHistory from './components/AgentChatHistory/AgentChatHistory';
import { displayErrorNotification } from '../../../../../utils/displayNudosStandardNotifications';
import { getAgentRequestHistory } from '../../../../../services/agentChat.service';
import { IAgentResponseData } from '../../../../../types/agentChat.types';
import './Tab2AgentChat.scss';

/**
 * Componente principal para la pestaña "Pregunta a Bordi"
 * Contiene dos secciones: la ventana de chat y el historial de consultas
 */
const Tab2AgentChat: FC = () => {
  const [historyItems, setHistoryItems] = useState<IAgentResponseData[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [question, setQuestion] = useState<string>();
  const [selectedHistoryResponse, setSelectedHistoryResponse] = useState<IAgentResponseData>();

  const handleSelectHistoryItem = (item: IAgentResponseData) => {
    setQuestion(item.question);
    setSelectedHistoryResponse(item);
  };

  const handleSetQuestion = (newQuestion?: string) => {
    setQuestion(newQuestion);
    if (newQuestion) return;
    setSelectedHistoryResponse(undefined);
  };

  const handleGetAgentRequestHistory = async () => {
    try {
      setIsLoading(true);
      const data = await getAgentRequestHistory();
      setHistoryItems(data);
    } catch (err) {
      displayErrorNotification();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetAgentRequestHistory();
  }, []);

  return (
    <div className="tab2AskBordi">
      <AgentChatWindow
        question={question}
        handleSetQuestion={handleSetQuestion}
        selectedHistoryResponse={selectedHistoryResponse}
        refreshHistory={handleGetAgentRequestHistory}
      />
      <AgentChatHistory
        question={question}
        historyItems={historyItems}
        isLoading={isLoading}
        handleSetQuestion={handleSetQuestion}
        handleSelectHistoryMessage={handleSelectHistoryItem}
      />
    </div>
  );
};

export default Tab2AgentChat;
